<template>
    <div class="menu-bar">
        <div class="icons-main"
             v-bind:class="{ expand: iconsMainCollapsed, 'c-dropdown-collapsed': !fixedMainIcon, fixed: fixedMainIcon}">
            <div class="icon-visibility-container">
                <div class="icon" v-bind:class="icon.icon" v-for="(icon, i) in computedIconsMain" :key="i"></div>
            </div>
            <i class="fas fa-sort-down"></i>
        </div>

        <div v-show="loggedIn" class="icons-nav collapseable">
            <div class="button" v-for="(icon, i) in iconsNav" :key="i"
                 v-on:click="ToggleDropDown($event, icon.items, 0, 10)">
                <i class="fas" v-bind:class="icon.icon"></i>
                <router-link class="router-link" v-if="icon.link" :to="{ name: icon.link, params: { storeId: storeId } }"></router-link>
                <div class="label">{{icon.label}}</div>
            </div>
            <div class="button collapsed" v-on:click="ToggleDropDown($event, iconsNav, 0, 10)">
                <i class="fas fa-cog"></i>
                <div class="label">Menu</div>
            </div>
        </div>
        <div v-if="loggedIn" class="login">
            <div class="fas fa-lightbulb" role="button" @click="toggleDarkMode()" style="margin-top:3px;"></div>
            <router-link :to="{name: 'storesettings'}"><div class="fas fa-cog cog-correction"></div></router-link>
            <div class="dividerh"></div>
            <searchbar :searchbar="searchbarItems"/>
            <div class="dividerh"></div>
            <div class="user-logged" v-on:click="ToggleDropDown($event, user.items, -9, 10)">
                <div class="picture" v-bind:style="{ backgroundImage: 'url(' + my_image + ')' }"></div>
                <div class="label">{{ userFullname }}</div>
            </div>
            <div class="dividerh"></div>
            <div class="icon icon-app-switch" v-on:click="ToggleDropDown($event, computedIconsMain, -80, 10, 87)"></div>

            
            <div class="dividerh"></div>
            <i class="fas fa-bell bell-correction">
                <div class="notification" v-bind:class="{big: eventNumber > 99}">{{ eventNumber }}</div>
                <router-link class="router-link" to="employeedatarequestoverview"></router-link>
            </i>
            
            <div class="dividerh"></div>
            <a @click="logout()"><i class="fas fa-sign-out-alt" role="button"></i></a>
        </div>
        <div v-else class="login">
            <div class="user-logged" v-on:click="login()">
                <div class="picture" v-bind:style="{ backgroundImage: 'url(' + my_image + ')' }"></div>
                <div class="label">Login</div>
            </div>
            <div class="dividerh"></div>
            <div class="icon icon-app-switch" v-on:click="ToggleDropDown($event, computedIconsMain, -80, 10, 87)"></div>
        </div>
        <dropdownlogin ref="dropdownlogin"/>
        <dropdown ref="dropdown" v-for="(dropdown, i) in dropdowns" :dropdown="dropdown" :key="i"/>

        <iframe id="scframe" style="display: none;" src="https://supportchat.meindienstplan.at/assets/modules/channel-web/lsproxy.html" width="10" height="10"> 
            <!--Supportchat iFrame for user token clearance -->
        </iframe>
        <iframe id="authframe" style="display: none;" src="https://account.meindienstplan.at/static/lsproxy.html" width="10" height="10">
            <!-- Auth IFrame -->
        </iframe>
        <accountPreferences ref="accountPreferences"/>
    </div>
</template>

<script>

    import dropdown from './uicomponents/dropdown.vue'
    import dropdownlogin from './uicomponents/dropdownlogin.vue'
    import searchbar from './uicomponents/searchbar.vue'
    import accountPreferences from './AccountPreferences.vue'
    import { mapState } from 'vuex';
    import { loadavg } from 'os';

    export default {
        name: 'MenuBar',
        components: {
            dropdown,
            dropdownlogin,
            searchbar,
            accountPreferences
        },
        data() {
            return {
                localStorageSupported: false,
                my_image: 'https://fileserver1.meindienstplan.de/api/file?id=d55fd03c-9999-4a48-8515-906585d0bc0e&accessToken=ALPW6DGLB92U2U0S',
                fixedMainIcon: true,
                searchbarItems: {},
                dropdowns: [],
                processed: [],
                toggled: false,
                iconsMainCollapsed: false,
                eventNumber: 0,
                iconsNav: [
                    {label: 'Dienstplan', icon: 'fa-calendar-check', link: 'roster'},
                    {label: 'Umsatzplanung', icon: 'fa-chart-line', link: 'storesalesmain'},
                    {label: 'Schichtplanung', icon: 'fa-tools', link: 'planning'},
                    {label: 'Abwesenheiten', icon: 'fa-umbrella-beach', link: 'preferences'},
                    {label: 'Mitarbeiter', icon: 'fa-users', link: 'employeesnew'},
                    {label: 'Kalender', icon: 'fa-calendar', link: 'calendar'},
                    {label: 'Betriebseinstellung', icon: 'fa-building', link: 'storemain'}
                ],
                iconsNavCollapsed: [
                    {label: 'Dienstplan', icon: 'fa-calendar-check', link: 'roster'},
                    {label: 'Umsatzplanung', icon: 'fa-chart-line', link: 'storesalesmain'},
                    {label: 'Schichtplanung', icon: 'fa-tools', link: 'planning'},
                    {label: 'Abwesenheiten', icon: 'fa-umbrella-beach', link: 'preferences'},
                    {label: 'Mitarbeiter', icon: 'fa-users', link: 'employeesnew'},
                    {label: 'Betriebseinstellung', icon: 'fa-building', link: 'storemain'},
                    {
                        label: 'Betrieb', icon: 'fa-building', items: [
                        {label: 'Betriebe', icon: 'fa-building'},
                    ]
                    }],
                user: {
                    items: [
                        {label: 'Mein Account', externalLink: 'https://account.meindienstplan.at'}
                    ]
                },
                userInfo: {
                    firstname: '',
                    lastname: '',
                    image_url: ''
                }
            }
        },
        computed: {
            computedIconsMain() {
                let sub = this.getSubDomain();
                let urls = []
                if(sub === "staging") {
                    urls =  ["https://account.meindienstplan.at/#/?redirect=stagingmzlogin", 'https://account.meindienstplan.at/#/?redirect=stagingmplogin', 'https://account.meindienstplan.at/#/?redirect=stagingmdcorelogin'];
                } else if(sub === "development") {
                    urls =  ["https://account.meindienstplan.at/#/?redirect=stagingmzlogin", 'https://account.meindienstplan.at/#/?redirect=stagingmplogin', 'https://account.meindienstplan.at/#/?redirect=stagingmdcorelogin'];
                } else {
                     urls =  ["https://account.meindienstplan.at/#/?redirect=mzlogin", 'https://account.meindienstplan.at/#/?redirect=mplogin', 'https://account.meindienstplan.at/#/?redirect=mdcorelogin'];
                }
                
                let iconsMain = [
                    {icon: 'icon-main-mz', label: 'Meine Zeiterfassung', externalLink: urls[0]},
                    {icon: 'icon-main-mp', label: 'Mein Player', externalLink: urls[1]},
                    {icon: 'fa-user', label: 'Mein Kundencenter', externalLink: urls[2]}
                ];

                return iconsMain;

            },
            userFullname: function(){
                return this.userInfo.firstname + ' ' + this.userInfo.lastname
            },
            sortProcessedAlphaNum : function()  {
                function compare( a , b ){
                    var reA = /[^a-zA-Z]/g;
                    var reN = /[^0-9]/g;
                    var aA = a.label.replace(reA, "");
                    var bA = b.label.replace(reA, "");
                    if (aA === bA) {
                        var aN = parseInt(a.label.replace(reN, ""), 10);
                        var bN = parseInt(b.label.replace(reN, ""), 10);
                        return aN === bN ? 0 : aN > bN ? 1 : -1;
                    } else {
                        return aA > bA ? 1 : -1;
                    }
                }
                return this.processed.sort(compare);
            },
            storeId() {
                return this.$store.state.storeId;
            },
            loggedIn() {
                return this.$store.state.loggedIn;
            }
            
        },
        watch: {
            storeId(newVal, oldVal) {
               if(newVal){
                   console.log("Changed storeId");
                   this.loadPermissions();
               }
            },
            loggedIn(newVal, oldVal){
                if(newVal){
                    this.loadPermissions();
                    this.loadUserInfo();
                        
                }
            }
        },
        created() {
            
        },
        mounted() {
            this.initViewMode();
            if(this.supportsHTML5Storage()){
                this.localStorageSupported = true;
            }
            if(this.localStorageSupported){
                //get JWT from localstorage if it exists, store it in vuex then delete it from localstorage
                //this is needed for development environments were jwt needs to be set manually because our origin is localhost and cant be gotten from auth iframe
                let jwt = localStorage.getItem('md_token');
                
                if(jwt != undefined){
                    console.log("got jwt from local storage")
                    this.$store.commit('setJWT', {jwt: jwt});
                    //TODO: UNCOMMENT IN PRODUCTION
                    //localStorage.removeItem('md_token');
                }
            }
        
            let view = this;

            let jwtqs = this.getQueryStringValue("jwt");
            if(!this.$helpers.isBlank(jwtqs)){
                console.log("got jwt from qs")
                localStorage.setItem("md_token", jwtqs)
                this.$store.commit('setJWT', {jwt: jwtqs});
            }

            if(!view.$helpers.isBlank(view.$store.state.jwt)){
                    view.login();
            } 
            

            // support chat bot bubble
            window.onload = function() { 
                var authframe = document.getElementById('authframe');
                var authwin; 
                // some browser (don't remember which one) throw exception when you try to access 
                // contentWindow for the first time, it work when you do that second time 
                try { 
                    authwin = authframe.contentWindow; 
                } catch(e) { 
                    authwin = authframe.contentWindow; 
                }

                console.log('Window onload function');
                localStorage.setItem('sc_autostart', '1');
                var scframe = document.getElementById('scframe'); 
                var winsc; 
                // some browser (don't remember which one) throw exception when you try to access 
                // contentWindow for the first time, it work when you do that second time 
                try { 
                    winsc = scframe.contentWindow; 
                } catch(e) { 
                    winsc = scframe.contentWindow; 
                }
                // clear botpress local storage
                winsc.postMessage(JSON.stringify({key: 'bp/socket/user', method: "remove"}), "*");
            
                window.onmessage = function(e) { 
                    if (e.origin === "https://account.meindienstplan.at") {
                            
                        let response = e.data;
                        //console.log(response);
                        if(response.key === "md_token"){
                            console.log("got token from account server")
                            view.$store.commit('setJWT', {jwt: response.data});
                            if(!view.$helpers.isBlank(view.$store.state.jwt) &&  !view.$store.state.loggedIn){
                                view.login();
                            }
                        }
                    } else if(e.origin == "https://supportchat.meindienstplan.at"){
                        let response = e.data;
                        if(response.key == 'removed:bp/socket/user'){
                            // old localstorage data removed, init webchat
                            console.log('Initializing support chat');
                            window.botpressWebChat.init({
                                host: 'https://supportchat.meindienstplan.at',
                                botId: 'mdpl-support',
                                botName: 'MDPL Support', // Name of your bot
                                //backgroundColor: '#dddddd', // Color of the background
                                //textColorOnBackground: '#666666', // Color of the text on the background
                                //foregroundColor: '#849fbf', // Element background color (header, composer, button..)
                                //textColorOnForeground: '#dddddd', // Element text color (header, composer, button..)
                                showConversationsButton: false, // Whether or not to show the conversations button
                                showUserName: false, // Whether or not to show the user's name
                                showUserAvatar: false, // Whether or not to show the user's avatar
                                enableTranscriptDownload: false, // Whether or not to show the transcript download button
                                enableArrowNavigation: false, //Whether or to to support arrow navigation (e.g scroll conversation, focus on buttons)
                                enableReset: true, // Whether or not reset button will be shown to the user
                                showBotInfoPage: true,
                                showBotInfo: true,
                                extraStylesheet: 'https://supportchat.meindienstplan.at/assets/modules/channel-web/custom.css',
                            });
                        } else if(response.name == 'webchatLoaded'){
                            console.log('Webchat loaded, sending toggle info command');
                            setTimeout(function(){
                                var scAutostart = localStorage.getItem('sc_autostart');
                                if(scAutostart == '1'){
                                    console.log('Chat autostart');
                                    window.botpressWebChat.sendEvent({ type: 'toggleBotInfo' });
                                    
                                    // proactive trigger to autostart the chat
                                    window.botpressWebChat.sendEvent({
                                        type: 'proactive-trigger',
                                        channel: 'web',
                                        payload: {
                                            text: 'smth'
                                        }
                                    });
                                }else{
                                    console.log('Skipping chat autostart');
                                }
                            }, 60000);
                        } else if(response.name == 'webchatOpened'){
                            console.log('Webchat opened, disabling autostart if not triggered yet');
                            localStorage.setItem('sc_autostart', '0');
                        }
                    }
                }; 
                // request JWT from auth iframe 
                authwin.postMessage(JSON.stringify({key: 'md_token', method: "get"}), "*"); 
            }; 
           
        },
        methods: {
            initViewMode(mode = "daymode"){
                let body = document.getElementsByTagName('body')[0];
                if(body.classList.length == 0) {
                    body.classList.add(mode);
                }
            },
            toggleDarkMode(){
                let body = document.getElementsByTagName('body')[0];
                if(body.classList.length > 0) {
                    var cur = body.classList[0];
                    if(cur == "nightmode"){
                        body.classList.remove("nightmode");
                        body.classList.add("daymode");
                    }else if(cur == "daymode"){
                        body.classList.remove("daymode");
                        body.classList.add("nightmode");
                    }   
                }else{
                    body.classList.add("daymode");
                }
            },
            loadPermissions: function() {
                let view = this;
                let url = '/api/sec/permission/me';
                let params = {
                   storeId: view.$store.state.storeId,
                }
                return this.axios({
                    method: 'get',
                    params: params,
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                }).then(response => {
                    return new Promise((resolve, reject) => {
                        let permissions = {};
                        for (let i = 0; i<response.data.length; i++){
                            if(!permissions[response.data[i].roleId]){
                                permissions[response.data[i].roleId] = []
                            }
                            permissions[response.data[i].roleId].push(response.data[i].roleId);
                        }

                        view.$store.commit('setPermissions', {permissions: permissions});
                        
                            
                        resolve("SUCCESS")
                        
                    })
                            
                }).catch(function (error) {
                    return new Promise((resolve, reject) => {
                        
                        reject(error)
                        
                    })
                })
            },
            loadStores : function() {
                let view = this;
                let url = '/api/semi/stores';

                return this.axios({
                    method: 'get',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                }).then(response => {
                    return new Promise((resolve, reject) => {
                        for (var x in response.data){
                            
                            var entry = response.data[x];
                            view.processed.push({label: entry.name, id: entry.id, companyId: entry.companyId});
                        }

                        //Sort the Stores AlphaNumeric
                        this.sortProcessedAlphaNum;

                        var selectedLabel = '';
                        if(!view.$store.state.storeId){
                            var first = response.data[0];
                            view.$store.commit('setStoreId', {storeId: first.id});
                            view.$store.commit('setCompanyId', {companyId: first.companyId});
                            
                            selectedLabel = first.name;
                            view.$router.push({ name: 'roster', params: { storeId: view.$store.state.storeId } });
                        }else{
                            
                            for (var x in response.data){
                                var entry = response.data[x];
                                if(entry.id == view.$store.state.storeId) selectedLabel = entry.name;
                            }
                        }
                        view.searchbarItems = {
                            toggled: false,
                            displayedItems: [],
                            input: selectedLabel,
                            items: this.processed,
                            onceSelected: function ($event, item, searchbar){
                                var name = view.$route.name;
                                
                                view.$store.commit('setStoreId', {storeId: item.id});
                                view.$store.commit('setCompanyId', {companyId: item.companyId});
                                view.$router.push({ name: name, params: { storeId: view.$store.state.storeId } });
                                
                            }
                        }           
                        resolve("SUCCESS")
                        
                    })
                            
                }).catch(function (error) {
                    return new Promise((resolve, reject) => {
                        
                        reject(error)
                        
                    })
                })
                    
            },
            loadUserInfo: function(){
                let view = this;
                let url = '/api/semi/user/me';
                this.axios({
                    method: 'get',
                    headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                    },
                    url: url
                }).then(response => {
                    view.userInfo.firstname = response.data.firstname;
                    view.userInfo.lastname = response.data.lastname;
                    if(response.data.profileimage){
                        view.userInfo.image_url = response.data.profileimage.url;
                        view.my_image = view.userInfo.image_url;
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            Init: function (styles) {
                this.styles = styles;
            },
            ToggleCollapse: function ($event) {
                var event = $event;
                event.currentTarget.parentElement.classList.toggle("show");
            },
            ToggleDropDown: function ($event, selection, offsetx, offsety, pointerOffset) {
                if (!selection || selection.length === 0) return;
                var event = $event;
                var box = event.currentTarget.getBoundingClientRect();
                var dropdowns = this.dropdowns;
                if (selection === this.iconsNav && window.innerWidth <= 750) {
                    selection = this.iconsNavCollapsed;
                }
                this.dropdowns.push({
                    items: selection,
                    el: event.currentTarget,
                    remainAfterSelect: true,
                    toggled: true,
                    offsetx: offsetx,
                    offsety: offsety,
                    posx: box.left + offsetx,
                    posy: box.bottom + offsety,
                    pointerOffset: pointerOffset,
                    onceSelected: function ($eventInner, item, dropdown) {
                        if (item.items && item.items.length > 0) {
                            var eventInner = $eventInner;
                            var boxInner = eventInner.currentTarget.getBoundingClientRect();
                            var temp = {
                                items: item.items,
                                el: eventInner.currentTarget,
                                offsetx: offsetx + 130,
                                offsety: offsety - 30,
                                posx: box.left + offsetx + 130,
                                toggled: true,
                                posy: boxInner.bottom - 30,
                                pointerDirection: 3,
                                pointerOffset: pointerOffset,
                                parentCallback: function () {
                                    dropdown.toggled = false
                                }
                            };
                            dropdowns.push(temp);
                        }
                    }
                });
            },
            ToggleDropDownMenuNav: function ($event, selection, offsetx, offsety) {
                var event = $event;
                var box = event.currentTarget.getBoundingClientRect();
                var dropdowns = this.dropdowns;
                var temp = {
                    el: event.currentTarget,
                    offsetx: offsetx,
                    offsety: offsety,
                    posx: box.left + offsetx,
                    posy: box.bottom + offsety,
                    items: selection.items,
                    toggled: true,
                    onceSelected: function ($eventInner, item, dropdown) {
                        dropdowns = dropdowns.filter(d => d !== temp);
                    }
                };
                this.dropdowns.push(temp);
                /*this.$refs.dropdown.Init(selection.items, {
                    el: event.currentTarget,
                    posx: box.left + offsetx,
                    posy : box.bottom + offsety,
                });*/
            },
            ToggleDropDownUser: function ($event, user, offsetx, offsety) {
                var event = $event;
                var box = event.currentTarget.getBoundingClientRect();
                this.$refs.dropdown.posx = box.left + offsetx;
                this.$refs.dropdown.posy = box.bottom + offsety;
                this.$refs.dropdown.items = user.items;
                this.$refs.dropdown.onceSelected = function () {
                    this.$forceUpdate()
                };
                this.$refs.dropdown.toggle();
            },
            ToggleDropDownLogin: function ($event, user, offsetx, offsety) {
                var event = $event;
                var box = event.currentTarget.getBoundingClientRect();
                this.$refs.dropdownlogin.posx = box.left + offsetx;
                this.$refs.dropdownlogin.posy = box.bottom + offsety;
                this.$refs.dropdownlogin.onceSelected = function () {
                    this.$forceUpdate()
                };
                this.$refs.dropdownlogin.toggle();
            },
            navigateTo(destination) {
                this.$router.push({ name: destination, params: { storeId: this.$store.state.storeId } })
                //this.$router.replace(destination)
                
            },
            getQueryStringValue: function (key) {
                    return decodeURIComponent(window.location.search.replace(new RegExp('^(?:.*[&\\?]' + encodeURIComponent(key).replace(/[\.\+\*]/g, '\\$&') + '(?:\\=([^&]*))?)?.*$', 'i'), '$1'));
            },
            supportsHTML5Storage: function () {
                try {
                    return 'localStorage' in window && window['localStorage'] !== null;
                } catch (e) {
                    return false;
                }
            },
            login: function() {
                if(!this.$helpers.isBlank(this.$store.state.jwt)){
                    let view = this;
                    let url = '/api/login';
                    
                    this.axios({
                        method: 'get',
                        headers: {
                        'AUTHORIZATION': "bearer "+this.$store.state.jwt
                        },
                        url: url
                    }).then(response => {
                        //view.$store.commit('setJWT', {jwt: jwt});
                        
                        view.loadStores().then(success=>{
                            //only really log in after stores are loaded
                            view.$store.commit('setLoggedIn', {loggedIn: true});
                            view.navigateTo('roster');
                        }), error => {
                            console.log(error);
                        };
                        
                        
                       
                    }).catch(function (error) {
                        view.$store.commit('clearJWT');
                        console.log(error);
                    })
                } else {
                    
                    let full = window.location.host
                    //window.location.host is subdomain.domain.com
                    let parts = full.split('.')
                    let sub = parts[0]
                    if(sub ==="staging") {
                        window.location = "https://account.meindienstplan.at/#/?redirect=stagingmdpl";
                    } else if(sub === "development") {
                        window.location = "https://account.meindienstplan.at/#/?redirect=devmdpl";
                    } else {
                        window.location = "https://account.meindienstplan.at/#/?redirect=mdpl";
                    }
                }	
            },
            logout: function () {
                localStorage.removeItem('md_token');
                localStorage.removeItem('selected_store');
                localStorage.removeItem('selected_company');
                
                let sub = this.getSubDomain();
                if(sub ==="staging") {
                    window.location = "https://account.meindienstplan.at/#/logout?redirect=stagingmdpl";
                } else if(sub === "development") {
                    window.location = "https://account.meindienstplan.at/#/logout?redirect=devmdpl";
                } else {
                    window.location = "https://account.meindienstplan.at/#/logout?redirect=mdpl";
                }

            },
            getSubDomain: function(){
                let full = window.location.host
                //window.location.host is subdomain.domain.com
                let parts = full.split('.')
                return parts[0]
            }
        },
       
        
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .menu-bar {
        position: relative;
        display: inline-block;
        width: 100%;
        height: 55px;
        background: var(--menu-bar);
        z-index: 10;
        padding: 5px;
    }

    .menu-bar > * {
        float: left;
    }

    .icons-main {
        border-radius: 5px;
        position: relative;
        display: inline-block;
        height: 30px;
        width: 30px;
        cursor: pointer;
    }

    .icons-main .icon {
        border-radius: 5px;
        height: 25px;
        width: 25px;
        cursor: pointer;
        margin: 0px;
    }

    .icons-main.fixed {
        padding: 10px;
        cursor: default;
    }

    .icons-main.fixed .icon-visibility-container {
        cursor: default;
    }

    .icons-main.fixed .icon, .icons-main.fixed .fas {
        cursor: default;
        display: none;
    }

    .icons-main.fixed .icon:first-child {
        display: inline-block;
    }

    .icons-nav {
        position: absolute;
        left: 60px;
        /* right: 0; */
        margin: auto;
        bottom: 15px;
        height: 25px;
        /*width: 640px;*/
        text-align: left;
    }

    .icons-nav > .button:nth-last-child(2) {
        margin: 0 23px;
    }

    .icons-nav > .button:nth-last-child(2):before {
        position: absolute;
        content: '';
        height: 25px;
        width: 1px;
        top: 0;
        bottom: 0;
        left: -15px;
        margin: auto;
        background: none;
        border-right: 1px solid var(--contrast-2);
        border-radius: 0;
        pointer-events: none;
    }

    .icons-nav > .button:nth-last-child(2):after {
        position: absolute;
        content: '';
        height: 25px;
        width: 1px;
        top: 0;
        bottom: 0;
        right: -15px;
        margin: auto;
        background: none;
        border-right: 1px solid var(--contrast-2);
        border-radius: 0;
        pointer-events: none;
    }

    .icons-selection {
        position: absolute;
        /*left: 695px;*/
        left: 583px;
        margin: auto;
        bottom: 15px;
        height: 25px;
        width: 270px;
        padding-top: 5px;
    }

    .icons-selection > * {
        float: left;
        margin-right: 5px;
    }

    .icons-selection > .label {
        margin-top: -2px;
    }

    .icons-selection > .fas {
        margin-right: 5px;
        margin-left: 1px;
        font-size: 16px;
    }

    .icons-selection .searchbar {
        width: 180px;
        margin-top: -6px;
        margin-left: 8px;
        position: relative;
    }

    .icon-main-mz, .icon-main-mp, .icon-main-md {

        background: url(https://www.meinezeiterfassung.at/images/md-logo.png);
        background-size: 100%;
        background-position: 50%;
        background-repeat: no-repeat;
    }

    .nightmode .icon-app-switch {
        background: url(/img/btn_app_switch_light.png);
        background-size: 100%;
        background-position: 50%;
        background-repeat: no-repeat;
    }

    .daymode .icon-app-switch {
        background: url(/img/btn_app_switch.png);
        background-size: 100%;
        background-position: 50%;
        background-repeat: no-repeat;
    }

    .login {
        position: absolute;
        font-size: 14px;
        top: 15px;
        font-weight: 600;
        right: 5px;
    }

    .login > * {
        /*color: #ffffff;*/
        float: left;
        position: relative;
        margin: 0 5px;
        transition: 0.2s;
        cursor: pointer;
    }

    .login > *:hover {
        color: #555555;
    }

    .login > .fa-bars {
        font-size: 20px;

        margin-top: -2px;
    }

    .login .user-logged {
        padding-left: 30px;
        padding-top: 8px;
        position: relative;
        margin-top: -6px;
    }

    .login .user-logged .label {
        pointer-events: none;

    }

    .login .user-logged .picture {
        position: absolute;
        left: 0;
        top: 6px;
        border-radius: 100px;
        height: 25px;
        width: 25px;
        background-position: 50% 50%;
        background-size: 100%;
        background-repeat: no-repeat;
        cursor: pointer;
    }

    .login .user-logged:hover .picture {
        box-shadow: 0 0 0 2.5px var(--contrast-4);
    }

    .login .user-logged .label {
        font-size: 13px;
        color: var(--contrast-4);
        margin-right: -0.1px;
        letter-spacing: 0.4px;
    }

    .login .fas {
        position: relative;
        color: var(--contrast-4);
        float: left;
        position: relative;
        margin: 0 5px;
        transition: 0.2s;
        cursor: pointer;
        font-size: 20px;
    }

    .login .fas .notification {
        position: absolute;
        background: #f43535;
        color: #ffffff;
        height: 16px;
        width: 16px;
        font-size: 8px;
        padding-right: 1px;
        padding-top: 4px;
        text-align: center;
        top: 12px;
        right: -8px;
        border-radius: 100px;
    }

    .login .fas .notification.big {
        height: 17px;
        width: 17px;
        font-size: 8px;
        padding-right: 1px;
        padding-top: 4px;
        text-align: center;
        top: 12px;
        right: -8px;
    }

    .login .fa-bell {
        font-size: 16px;
    }

    .login .fa-sign-out-alt {
        margin-top: 2px;
    }

    .login .icon {
        font-size: 16px;
        height: 25px;
        width: 25px;
        margin-top: 0px;
        margin-right: 4px;
    }

    .login .label {
        color: var(--contrast-4);
    }
    .login .cog-correction {
        padding-top: 3px;
        margin-right: -2px;
    }
    .login .bell-correction {
        padding-top: 5px;
    }
</style>
